var map = {
	"./bracelet_1.svg": 74767,
	"./earring_1.svg": 6279,
	"./earring_2.svg": 34772,
	"./jlux_1.svg": 93682,
	"./jlux_2.svg": 86817,
	"./jlux_3.svg": 51280,
	"./jlux_4.svg": 17167,
	"./jlux_5.svg": 73438,
	"./jlux_6.svg": 27613,
	"./mens_ring_1.svg": 81429,
	"./pendant_1.svg": 41823,
	"./ring_1.svg": 22917,
	"./ring_2.svg": 23782,
	"./ring_3.svg": 94967,
	"./ring_4.svg": 75160,
	"./ring_5.svg": 26377,
	"./ring_6.svg": 11290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17974;